import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { Shop, PagedResponseShop } from '../models/Shop';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})



export class ShopService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getShops():Observable<PagedResponseShop>{
    const data =  this.http.get<PagedResponseShop>(this.APIURL+'/Shop' + '?PageNumber=1&PageSize=100');
    this.messageService.add('Shop Service: fetched shops');
    return data;
  }
  getShopByLineId(lineId: number):Observable<PagedResponseShop>{
    const data = this.http.get<PagedResponseShop>(this.APIURL + '/Shop/GetShopByLineId/' + lineId);
    this.messageService.add('Shop Service: fetched shops');
    return data;
  }

    getNonSupportShopByLineId(lineId: number):Observable<PagedResponseShop>{
    const data = this.http.get<PagedResponseShop>(this.APIURL + '/Shop/GetNonSupportShopByLineId/' + lineId);
    this.messageService.add('Shop Service: fetched shops');
    return data;
  }
  searchShop : Shop[]=[];

  getShopByCompanyId(companyId: number):Observable<PagedResponseShop>{ 
    return  this.http.get<PagedResponseShop>(this.APIURL + '/Shop/GetShopByCompanyId/' + companyId)
    .pipe(tap(data => {this.searchShop = data.data;}))
  }

  getNonSupportShopByCompanyId(companyId: number):Observable<PagedResponseShop>{ 
    return  this.http.get<PagedResponseShop>(this.APIURL + '/Shop/GetNonSupportShopByCompanyId/' + companyId)
    .pipe(tap(data => {this.searchShop = data.data;}))
  }

  getShop(id: number): Observable<Shop> {
        const Shop =this.http.get<Shop>(this.APIURL+'/Shop/' + id);
    this.messageService.add(`Shop Service: fetched company with id=${id}`);
    return Shop;
  }

  shops : Shop[]=[];
  getShopSearch(value: string, shopName: string, companyId: number) :Observable<PagedResponseShop> {
    return  this.http.get<PagedResponseShop>(this.APIURL+'/Shop/GetShopSearch' + '?PageNumber=1&PageSize=10000' + "&Filter=" + value + "&ShopName=" +  shopName+ "&CompanyId=" +  companyId)
                     .pipe(tap(data => this.shops = data.data))
  }
}